import { Input } from "@/components/ui/input";
import { Unit } from "@/lib/sticker";
import { UnitSelector } from "./UnitSelector";

interface SizeInputProps {
  label: string;
  value: number;
  onChange: (value: string) => void;
  unit?: Unit;
  onUnitChange?: (unit: Unit) => void;
  showUnit?: boolean;
}

export const SizeInput = ({
  label,
  value,
  onChange,
  unit,
  onUnitChange,
  showUnit = true,
}: SizeInputProps) => {
  return (
    <div className="flex items-center gap-2">
      <div className="text-xs text-muted-foreground w-4 text-center">
        {label}
      </div>
      <Input
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-7 text-xs px-2 flex-1 rounded-sm border-border/50"
      />
      {showUnit && unit && onUnitChange ? (
        <UnitSelector unit={unit} onUnitChange={onUnitChange} />
      ) : (
        <div className="w-16" />
      )}
    </div>
  );
};
